module.exports = __webpack_public_path__ + "upload_doc.08d11687132a20489ab7eb3ec3899407.svg";